import angular from 'angular';

i18nConfig.$inject = ['tmhDynamicLocaleProvider'];

export default function i18nConfig(tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern(
        `//cdnjs.cloudflare.com/ajax/libs/angular-i18n/${angular.version.full}/angular-locale_{{locale}}.min.js`
    );
}
